import { type FunctionComponent } from 'react';

import { LoadingSpinner } from '@kanda-libs/ks-design-library';

import PleaseWaitOverlay from 'components/PleaseWaitOverlay';

const HummChecking: FunctionComponent = () => (
  <>
    <PleaseWaitOverlay
      icon="check-circle-color"
      title="We're just checking the status of your finance application with our lender, Humm."
      labelLine1="This process can take a few minutes whilst they let us know if you've been approved or not. Please wait here until we have receved confirmation from them, and any next steps will be shown here"
    />
    <LoadingSpinner stroke="purple-300" className="mx-auto mt-8" />
  </>
);

export default HummChecking;
